var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AhaInfoBox',[_vm._v("\n  Some smartphones may prevent audio tracks from automatically playing.\n  In that case, the audience will see a prompt to press the play button.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }